import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { UserStore } from '../store/user.store';

export const authGuard: CanActivateFn = () => {
  const router = inject(Router);
  const userStore = inject(UserStore);
  if (userStore.isAuthenticated()) return true;

  return router.createUrlTree(['/login']);
};
